<script setup lang="ts">
import Translator from "@/utils/common/Translator.ts";
import NamaIcon from "@/components/icons/NamaIcon.vue";
import WidgetContainer from "@/components/EditView/widgets/WidgetContainer.vue";
import {QuestionFieldsPresenter} from "@/utils/presenters/QuestionFieldsPresenter.ts";
import {onMounted} from "vue";
import {useQuestionList, MenuItem} from "./useQuestionList.ts";
import QuestionField = namaTypes.QuestionField;

const props = defineProps<{
  presenter: QuestionFieldsPresenter, questionField: QuestionField,
  doNotApplyThemeLayouts: boolean
}>()

const {
  displayedItems, isLoading, isItemSelected, toggleItem, loadItems,
} = useQuestionList(props.presenter, props.questionField);

onMounted(() => loadItems());

function chipLabel(item: MenuItem): string {
  return item.caption && item.caption !== item.code ? item.caption : item.code;
}
</script>

<template>
  <WidgetContainer
    :field="questionField"
    :entityType="presenter.entityType"
    :isFieldDisabled="false"
    :isFieldRequired="questionField.required"
    :doNotApplyThemeLayouts="doNotApplyThemeLayouts"
    :isInsideComposite="false">
    <template #icon>
      <NamaIcon :block="questionField" :presenter="presenter" class="tw-size-[22px] tw-text-[22px]"/>
    </template>
    <template v-slot:widget>
      <div v-if="isLoading" class="tw-flex tw-items-center tw-gap-2 tw-py-2 tw-px-2">
        <q-spinner size="16px" color="primary"/>
        <span class="tw-text-xs tw-text-black/50 dark:tw-text-white/50" v-text="Translator.translateId('loading')"/>
      </div>
      <div v-else-if="displayedItems.length"
           class="tw-flex tw-flex-wrap tw-items-center tw-gap-1 tw-rounded-md tw-p-1.5"
           :class="{'tw-border tw-border-black/10 dark:tw-border-white/20': !questionField.hideBorder}">
        <div v-for="item in displayedItems"
             :key="item.id"
             @click="toggleItem(item)"
             class="tw-relative tw-grow tw-overflow-hidden tw-rounded-md tw-select-none
                    tw-bg-gray-600/40 hover:tw-bg-gray-600/50
                    tw-px-2 tw-py-1 tw-flex tw-items-center tw-gap-1 tw-shadow-md tw-cursor-pointer">
          <span
            :class="{'!tw-opacity-100': isItemSelected(item)}"
            class="tw-absolute tw-inset-0 tw-opacity-[0.15] dark:tw-opacity-[0.08] -tw-z-0 tw-w-full tw-h-full tw-bg-primary-light dark:tw-bg-primary-dark tw-transition-opacity"/>
          <span
            v-text="chipLabel(item)"
            class="tw-text-white dark:tw-text-white/90 tw-text-[12px] tw-z-[1]"/>
        </div>
      </div>
      <div v-else class="tw-py-2 tw-px-2">
        <span class="tw-text-xs tw-text-black/50 dark:tw-text-white/50" v-text="Translator.translateId('noResults')"/>
      </div>
    </template>
  </WidgetContainer>
</template>
